"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addResources = exports.getNavigatorLocale = exports.isLocale = exports.locales = void 0;
const i18next_1 = __importDefault(require("i18next"));
const formatDate_1 = __importDefault(require("./formatDate"));
const ru_1 = __importDefault(require("./locales/ru"));
const en_1 = __importDefault(require("./locales/en"));
exports.locales = ['ru', 'en'];
const isLocale = (x) => exports.locales.includes(x);
exports.isLocale = isLocale;
const getNavigatorLocale = (navigator) => {
    var _a, _b;
    if ((_a = navigator.language) === null || _a === void 0 ? void 0 : _a.includes('ru')) {
        return 'ru';
    }
    if ((_b = navigator.languages) === null || _b === void 0 ? void 0 : _b.some(language => language.includes('ru'))) {
        return 'ru';
    }
    return 'en';
};
exports.getNavigatorLocale = getNavigatorLocale;
const i18nextInstance = i18next_1.default.createInstance({
    lng: 'ru',
    resources: {
        ru: ru_1.default,
        en: en_1.default,
    },
    ns: ['common', 'translation'],
    defaultNS: 'translation',
    interpolation: {
        escapeValue: false,
        format: function (value, format, lng) {
            if (!(0, exports.isLocale)(lng)) {
                return value;
            }
            if (value instanceof Date) {
                return (0, formatDate_1.default)(value, format, lng);
            }
            if (typeof value === 'number' && format === 'ordinal') {
                return numberToOrdinal[lng](value);
            }
            return value;
        },
    },
});
exports.default = i18nextInstance;
function addResources(resourcesByLang) {
    Object.keys(resourcesByLang).forEach(lang => {
        if (!(0, exports.isLocale)(lang)) {
            throw new Error(`Trying to add resources to an unsupported locale "${lang}".`);
        }
        Object.keys(resourcesByLang[lang]).forEach(ns => i18nextInstance.addResourceBundle(lang, ns, resourcesByLang[lang][ns], true));
    });
}
exports.addResources = addResources;
const numberToOrdinal = {
    ru: (number) => number + '-й',
    en: (number) => {
        let tail = number % 100;
        if (tail > 10 && tail < 19) {
            return number + 'th';
        }
        tail = number % 10;
        if (tail === 1)
            return number + 'st';
        if (tail === 2)
            return number + 'nd';
        if (tail === 3)
            return number + 'rd';
        return number + 'th';
    },
};
